import React from "react"
import types from "prop-types"
import { sectionShape } from "utils/propTypeShapes"
import { SectionBranchingConditionalCheck, SectionContainer } from "shared/form"
import SubmissionEditQuestions from "./SubmissionEditQuestions"

const SubmissionEditSection = ({ section, formAnswers, isFirstSection }) => {
  const { description, name, questions } = section

  return (
    <SectionBranchingConditionalCheck
      isFirstSection={isFirstSection}
      formAnswers={formAnswers}
      section={section}
    >
      <SectionContainer description={description} name={name}>
        <SubmissionEditQuestions questions={questions} formAnswers={formAnswers} />
      </SectionContainer>
    </SectionBranchingConditionalCheck>
  )
}

SubmissionEditSection.propTypes = {
  section: sectionShape.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formAnswers: types.object.isRequired,
  isFirstSection: types.bool.isRequired,
}

export default SubmissionEditSection
